import { inject, Injectable } from '@angular/core';
import { HttpClient, HttpParams } from "@angular/common/http";
import { Observable } from "rxjs";
import { IRespDireccion } from "../interfaces/buscar-direccion.interface";
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root'
})
export class BuscardorDireccionService {
  private apiUrl = environment.baseURL + 'direcciones/autocomplete';

  private readonly httpClient: HttpClient = inject(HttpClient);

  getDirecciones(direccion: string): Observable<IRespDireccion> {
    const params = new HttpParams().set('client-id', '4b9b9ab5b734408d915ec31751bbf114')
    return this.httpClient.get<IRespDireccion>(`${this.apiUrl}?address=${direccion}`, { params });
  }
}
